import NoteEdit from '../../src/legacy/NoteEdit.tsx';
export default NoteEdit;
